export default __webpack_public_path__ + "static/media/039-no-entry.8c968760.png";